/**
 * c-membership-sticky-cart.js
 *
 * メンバーシップページ用スティッキーカート制御
 * - IntersectionObserverでbuy_buttonsの可視状態を監視
 * - PRO/BASICの決済リンクボタンを表示/非表示切替
 */
(function () {
  'use strict';

  var stickyBar = document.getElementById('c-membership-sticky-cart');
  if (!stickyBar) return;

  // ===== GoSubスティッキー制御 =====
  function setGosubStickyVisibility(visible) {
    var gosub = document.getElementById('footer-nav_buy');
    if (!gosub) return;
    gosub.style.display = visible ? '' : 'none';
  }

  // ===== IntersectionObserver: buy_buttonsの可視状態監視 =====
  function initVisibilityObserver() {
    var originalBtn = document.querySelector('[data-add-to-cart]')
      || document.querySelector('a[href*="/account/login"][href*="membership"]')
      || document.querySelector('[id*="gosub"]');
    if (!originalBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
            setGosubStickyVisibility(true);
          } else {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
            setGosubStickyVisibility(false);
          }
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    observer.observe(originalBtn);
  }

  // ===== 初期化 =====
  function init() {
    initVisibilityObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
